export const I18N_CACHE_VERSION =
    process.env.NEXT_PUBLIC_I18N_VERSION ?? "dev";
